module.exports = __webpack_public_path__ + "src/assets/img/ic04.8b8b2daa.svg";